import { LtMaxPrice } from '~/Api/User/ProductGroup/LtMaxPrice/LtMaxPrice';
import { mapFinalCalculation, RawFinalCalculation } from '~/Api/User/ProductGroup/LtMaxPrice/mapFinalCalculation';
import { mapProduct, RawProduct } from '~/Api/User/ProductGroup/LtMaxPrice/mapProduct';
import { Reference } from '~/Api/User/ProductGroup/LtMaxPrice/Reference';

interface RawReference {
	decisionNumber: string | null;
	packageSize: number;
	referenceBasketVersion: string;
	historicProductDataViewDate: string | null;
	referencedProductType: string | null;
	dosageStrength: number | null;
}

export interface RawLtMaxPrice {
	finalCalculation: RawFinalCalculation;
	_links: { [key: string]: string };
	products: RawProduct[];
	reference: RawReference;
}

export const mapLtMaxPrice = (ltMaxPrice: RawLtMaxPrice): LtMaxPrice => {
	return new LtMaxPrice(
		new Reference(
			ltMaxPrice.reference.packageSize,
			ltMaxPrice.reference.referenceBasketVersion,
			ltMaxPrice.reference.historicProductDataViewDate !== null
				? new Date(ltMaxPrice.reference.historicProductDataViewDate)
				: null,
			ltMaxPrice.reference.referencedProductType,
			ltMaxPrice.reference.dosageStrength
		),
		ltMaxPrice.products.map(mapProduct),
		mapFinalCalculation(ltMaxPrice.finalCalculation),
		ltMaxPrice._links
	);
};
